import styled from 'styled-components'

const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0;
  & + & {
    margin-top: 16px;
  }
`
const Label = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.color.neutral.color4};
`
const Value = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.color.neutral.color3};
  white-space: pre-wrap;
`

type ProfileFieldRowProps = {
  label: string
  value?: string | null
  testId?: string
}

const ProfileFieldRow = ({ label, value, testId }: ProfileFieldRowProps) => (
  <Row data-testid={testId}>
    <Label>{label}</Label>
    <Value>{value || 'No information entered'}</Value>
  </Row>
)

export default ProfileFieldRow
